// extracted by mini-css-extract-plugin
export default {"container":"TopRightIcon_container__5k7OM"};